import { createFileRoute } from '@tanstack/react-router'
import { AnomalyDetectionPage } from 'pages/anomalyDetection/AnomalyDetectionPage'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import z from 'zod'

const enforceSiteId = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string(),
})

const RouteComponent = () => {
  const { siteId } = Route.useSearch()

  return <AnomalyDetectionPage siteId={siteId} />
}

export const Route = createFileRoute('/anomaly-detection/')({
  component: RouteComponent,
  validateSearch: enforceSiteId,
  staticData: {
    title: 'Anomaly Detection',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})
